import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Sparkles, Edit } from "lucide-react";
import styles from "./index.module.scss";
import { endPoints, PORTAL } from "../../../constants/urlConstants";
import { getCall } from "../../../services/apiService";
import { getProgramImage } from "../../../utils/commonFunctions";
import ArrowLeft from "../../../assets/images/arrow-left.svg";
import table from "../../../assets/images/table.svg"; // Assuming you have a table image for the new program option
import sparkle from "../../../assets/images/sparkle.svg"; // Assuming you have a sparkle image for the custom program option
import Loader from "../../../common/components/Loader";

const ChooseProgramPage = ({ onBack }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [programTypesData, setProgramTypesData] = useState([]);
  const fetchProgramsList = () => {
    setLoading(true);

    getCall(`${endPoints.programType}?limit=100&offset=0&searchText=`, undefined, PORTAL)
      .then((response) => {

        if (response?.data?.data) {
          setProgramTypesData(response.data.data.data);

          // Extract all programs from the nested structure
        } else {
          console.error("No data found in response");
        }
      })
      .catch((error) => {
        console.error("Error fetching programs:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchProgramsList();
  }, []);

  // Function to get CSS class based on program type
  const getProgramClass = (programTypeName) => {
    const name = programTypeName.toLowerCase();
    if (name.includes("hdb") || name.includes("msd")) {
      return "hdb";
    } else if (name.includes("entertainment") || name.includes("entrainment")) {
      return "entrainment";
    } else if (name.includes("tat")) {
      return "tat";
    }
    return "hdb"; // Default class
  };

  // Function to get background color based on program type
  const getProgramColors = (programTypeName) => {
    const name = programTypeName.toLowerCase();
    if (name.includes("hdb") || name.includes("msd")) {
      return { bgColor: "bg-red-600", textColor: "text-white" };
    } else if (name.includes("entertainment") || name.includes("entrainment")) {
      return { bgColor: "bg-blue-200", textColor: "text-gray-800" };
    } else if (name.includes("tat")) {
      return { bgColor: "bg-amber-900", textColor: "text-white" };
    }
    return { bgColor: "bg-gray-600", textColor: "text-white" }; // Default colors
  };

  const handleProgramClick = async (
    programTypeId: string,
    // programTypeName: string,
  ) => {
    navigate("/admin/add-program/hdb", {
      state: { programTypeId: programTypeId },
    });
    setLoading(true);
  };

  const handleBackClick = () => {
    if (onBack) {
      onBack();
    } else {
      navigate("/admin/action-cards");
    }
  };

  return (
    <div className={styles.container}>
      {loading && <Loader type="large" />}
      <div className={styles.mainContent}>
        <div className={styles.mainBody}>
          <div className={styles.contentWrapper}>
            <div className={styles.titleSection}>
              <div className={styles.titleWithBack}>
                <div>
                  <div className={styles.mainTitle}>
                    <img src={ArrowLeft} alt="Back" onClick={handleBackClick} />
                    Create program
                  </div>
                </div>
              </div>
            </div>
            <div>
              <p className={styles.subtitle}>
                Create a program from existing templates
              </p>
            </div>

            <div className={styles.programGrid}>
              {programTypesData.map((programType) => {
                const colors = getProgramColors(programType.name);
                const programClass = getProgramClass(programType.name);
                const programImage = programType.bannerUrl;

                return (
                  <div
                    key={programType.id}
                    onClick={() =>
                      handleProgramClick(programType.id, programType.name)
                    }
                    className={styles.programCard}
                  >
                    <div
                      className={`${styles.programCardImage} ${styles[programClass]}`}
                    >
                      <div className={styles.bannerContainer}>
                        <img src={programImage} alt={programType.name} />
                      </div>
                    </div>
                    <div className={styles.programCardContent}>
                      <h3 className={styles.programTitle}>
                        {programType.name}
                      </h3>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChooseProgramPage;
